// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-table[data-v-58c0c870] .q-table__card{-webkit-box-shadow:none;box-shadow:none}.container-table[data-v-58c0c870] .q-card__section--vert{padding:0!important;border:3px solid #e9f4f6;border-radius:12px}", ""]);
// Exports
module.exports = exports;
